module.exports = __webpack_public_path__ + "img/green_plus.d65095b0.svg";